import { Link } from "react-router-dom";
import { getUserRole } from "../fakeAuth";

export default function Sidebar() {
  const role = getUserRole();

  return (
    <div className="w-64 bg-gray-800 text-white min-h-screen p-6 space-y-6">
      <h2 className="text-2xl font-bold">Smart HR</h2>

      <nav className="space-y-2">
        {role === "hr" && (
          <>
            <Link to="/hr/dashboard" className="block p-2 rounded hover:bg-gray-700">Dashboard</Link>
            <Link to="/hr/employees" className="block p-2 rounded hover:bg-gray-700">Employees</Link>
            <Link to="/hr/attendance" className="block p-2 rounded hover:bg-gray-700">Attendance</Link>
            <Link to="/hr/payroll" className="block p-2 rounded hover:bg-gray-700">Payroll</Link>
            <Link to="/hr/leaves" className="block p-2 rounded hover:bg-gray-700">Leaves</Link>
            <Link to="/hr/reports" className="block p-2 rounded hover:bg-gray-700">Reports</Link>
            <Link to="/hr/onboarding" className="block p-2 rounded hover:bg-gray-700">Onboarding</Link>
            <Link to="/hr/recruitment" className="block p-2 rounded hover:bg-gray-700">Recruitment</Link>
            <Link to="/hr/documents" className="block p-2 rounded hover:bg-gray-700">Documents</Link>
            <Link to="/hr/notifications" className="block p-2 rounded hover:bg-gray-700">Notifications</Link>
            <Link to="/hr/calendar" className="block p-2 rounded hover:bg-gray-700">HR Calendar</Link>
            <Link to="/hr/settings" className="block p-2 rounded hover:bg-gray-700">Settings</Link>
          </>
        )}

        {role === "manager" && (
          <>
            <Link to="/manager/dashboard" className="block p-2 rounded hover:bg-gray-700">Dashboard</Link>
            <Link to="/manager/team" className="block p-2 rounded hover:bg-gray-700">Team</Link>
            <Link to="/manager/attendance" className="block p-2 rounded hover:bg-gray-700">Attendance</Link>
            <Link to="/manager/leaverequests" className="block p-2 rounded hover:bg-gray-700">Leave Requests</Link>
            <Link to="/manager/timesheetapprovals" className="block p-2 rounded hover:bg-gray-700">Timesheet Approvals</Link>
            <Link to="/manager/announcements" className="block p-2 rounded hover:bg-gray-700">Announcements</Link>
          </>
        )}

{role === "employee" && (
  <>
    <Link to="/employee/dashboard" className="block p-2 rounded hover:bg-gray-700">Dashboard</Link>
    <Link to="/employee/profile" className="block p-2 rounded hover:bg-gray-700">Profile</Link>
    <Link to="/employee/onboarding" className="block p-2 rounded hover:bg-gray-700">Onboarding</Link>
    <Link to="/employee/apply-leave" className="block p-2 rounded hover:bg-gray-700">Apply Leave</Link>
    <Link to="/employee/attendance" className="block p-2 rounded hover:bg-gray-700">Attendance</Link>
    <Link to="/employee/payroll" className="block p-2 rounded hover:bg-gray-700">Payslips</Link>
    <Link to="/employee/documents" className="block p-2 rounded hover:bg-gray-700">Documents</Link>
    <Link to="/employee/notifications" className="block p-2 rounded hover:bg-gray-700">Notifications</Link>
    <Link to="/employee/calendar" className="block p-2 rounded hover:bg-gray-700">HR Calendar</Link>
  </>
)}

      </nav>
    </div>
  );
}
